import React from 'react';
import List, { defaultFilters } from '../../cruds/List';
import Edit from '../../cruds/Edit';
import { stringNotBlank } from '../../cruds/validators';
import Table, { Column } from '../../components/container/Table';
import { EditButton, DeleteButton } from '../../components/output/CrudButton';
import OutputValue from '../../components/output/OutputValue';
import DownloadButton from '../../components/output/DownloadButton';
import InputText from '../../components/input/InputText';
import MainContainer from '../../components/MainContainer';
import { Switch, Route } from 'react-router-dom';
import WithRole, { withRoles } from '../../components/container/WithRole';

const ENTITY_NAME = 'activities';
const TITLE = 'activities.title';

const CrudEdit = props => {
  const validators = [
    stringNotBlank('name', 'activities.err.name'),
  ];
  return (
    <Edit {...props}
      title={TITLE}
      entityName={ENTITY_NAME}
      entityRoute={ENTITY_NAME}
      entityId={props.match.params.number}
      validators={validators}
    >
      <InputText name="name" label="activities.name" required />
    </Edit>
  );
};

const exportButtons = (filters, context, toggleModal) => {
  return (
    <span>
      <DownloadButton from={ENTITY_NAME}
          filters={filters}
          type="application/vnd.ms-excel"
          extension="xls"
          tooltip="general.export"
          handleError={toggleModal}
      />
      <DownloadButton
          from={ENTITY_NAME}
          filters={filters}
          type="application/pdf"
          extension="pdf"
          tooltip="general.print"
          iconType="printer"
          handleError={toggleModal}
      />
    </span>
  );
};

const CrudList = props => {
  const table = <Table>
                  <Column label="activities.name" orderingName="NAME"><OutputValue name="name" /></Column>
                  <Column>
                    <WithRole roles={['A', 'B']}>
                      <EditButton entityRoute={props.match.url} />
                    </WithRole>
                    <WithRole roles={['A', 'B']}>
                      <DeleteButton />
                    </WithRole>
                  </Column>
                </Table>;

  return <List title={TITLE}
                entityName={ENTITY_NAME}
                entityRoute={ENTITY_NAME}
                component={table}
                filters={defaultFilters()}
                additionalButtons={exportButtons}
                defaultOrdering="NAME"
                hideAddButton = {!withRoles(['A', 'B'])}
          />;
};

const Activities = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Activities;



// WEBPACK FOOTER //
// ./src/main/pages/registry/Activities.js